import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ContactInfoModel } from "../../models/borrower-portal/contact-info-model";
import { OrderPaymentHistory } from "../../models/order-payment-history.model";
import { PaymentInformation } from "../../models/payment-information.model";
import { BorrowerVerificationOrderHistory } from "projects/borrower-app/src/app/models/borrower-verification-order-history.model";
import { BasePortalService } from "../../services/base-portal.service";

@Injectable()
export class BorrowerPortalService extends BasePortalService {

  protected get baseUrl(): string {
    return "BorrowerPortal";
  }

  public getContactInfoForApplication(appId: number): Observable<ContactInfoModel> {
    return this._dataService.get(`api/${this.baseUrl}/GetBorrowerContactInfoForApplication/${appId}`);
  }

  orderPayment = (
    taskId: number,
    req: PaymentInformation
  ): Observable<OrderPaymentHistory> => {
    const url = `api/${this.baseUrl}?loanDocTaskId=${taskId}`;
    return this._dataService.post(url, req);
  };

  getVerificationOrderHistoryForTask = (loanDocTaskId: number): Observable<BorrowerVerificationOrderHistory> => {
    const url = `api/online-app/borrower-verification/orders/task/${loanDocTaskId}`;
    return this._dataService.get(url);
  };
}
